import { ClientResources } from "@app/api2/api";
import React from "react";

export const TranslationContext = React.createContext<ClientResources>(window.translation);

export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const translation = window.translation;

  return (
    <TranslationContext.Provider value={translation}>
      {children}
    </TranslationContext.Provider>
  );
};

// Custom hook to use the TranslationContext
export const useTranslation = () => React.useContext(TranslationContext);
